'use client'

import { useEffect } from 'react'
import mixpanel from 'mixpanel-browser'

export function MixpanelProvider() {
  useEffect(() => {
    // Initialize Mixpanel
    mixpanel.init('606c40a8670985f4b2bab47da763a0b6', {
      debug: true,
      track_pageview: true,
      persistence: 'localStorage',
      autocapture: true,
      record_sessions_percent: 100,
    })
  }, [])

  return null
}

